import React, { useEffect, useState } from "react";
import { Modal } from "react-bootstrap";
import { useLanguage } from "../../../../Translations/LenguageContext";
import ErrorMessage from "../../../../Components/ErrorMessage";
import Spinner from "../../../../Components/Spinner";
import { useParams } from "react-router-dom";

const DeleteUserModal = ({ show, handleClose, recordObject, fetchRecords, endpoint, record_type, message }) => {
    const { t } = useLanguage()
    const { project_id, db_id } = useParams();
    const user_id = sessionStorage.getItem("user_id")
    const [error, setError] = useState({ message: "", display: false });
    const [inputValue, setInputValue] = useState("");
    const [isButtonDisabled, setIsButtonDisabled] = useState(true);
    const [loadingDel, setLoadingDel] = useState(false)
    const [recordId, setRecordId] = useState("");
    const [orgName] = useState("Delete");

    useEffect(() => {
        if (recordObject) {
            setRecordId(recordObject._id || "");
        }
    }, [recordObject]);

    const handleInputChange = (e) => {
        const value = e.target.value;
        setInputValue(value);

        if (value === record_type) {
            setIsButtonDisabled(false);
        } else {
            setIsButtonDisabled(true);
        }
    };

    const handleCloseModal = () => {
        setRecordId("")
        setIsButtonDisabled(true);
        handleClose()
        setError({ message: "", display: false })
        setInputValue("")
    }

    const deleteOrganization = async () => {
        try {
            setLoadingDel(true)
            const response = await fetch(`https://backend.erioon.com/${endpoint}`, {
                method: "DELETE",
                headers: {
                    "Content-Type": "application/json",
                },
                body: JSON.stringify({ user_id: user_id, db_id: db_id, access_id: recordId }),
            });
            setLoadingDel(false)
            if (response.ok) {
                handleCloseModal()
                fetchRecords()
            } else {
                setError({ message: t.err_delete_general, display: true })
            }
        } catch (err) {
            setLoadingDel(false)
            setError({ message: t.err_delete_general, display: true })
        }
    };

    return (
        <Modal show={show} onHide={handleCloseModal} className="modal_delete">
            <div className="modal_header">
                <p>{t.delete_modal.title}</p>
                <i className="fa-solid fa-x" onClick={handleCloseModal}></i>
            </div>
            <div className="modal_body">
                <p className="warning_delete_message">{message}</p>
                <div className="delete_action_cont">
                    <p className="type_phrase_delete">{t.delete_modal.confirm_del_mex} <strong>{record_type}</strong></p>
                    <input
                        className="delete_input"
                        placeholder={record_type}
                        value={inputValue}
                        onChange={handleInputChange}
                    />
                </div>

            </div>
            <div className="modal_footer">
                <ErrorMessage err={error} />
                <div className="footer_btn_cont">
                    <button
                        className={`delete_btn ${isButtonDisabled ? "" : "delete_btn_active"}`}
                        onClick={deleteOrganization}
                        disabled={isButtonDisabled}
                    >
                        {loadingDel ? (
                            <Spinner loading={loadingDel} />
                        ) : (
                            <>{t.delete}</>
                        )}
                    </button>
                    <button className="cancel_btn" onClick={handleCloseModal}>{t.cancel}</button>
                </div>
            </div>
        </Modal>
    );
};

export default DeleteUserModal;
